/* Scoped to the full cart page. Intercept removal before Turbo's body handler submits the form. */
(() => {
  if (window.pufforaCartRemovalInstalled) return;
  window.pufforaCartRemovalInstalled = true;
  let busy = false;
  const stop = event => { event.preventDefault(); event.stopImmediatePropagation(); };

  document.addEventListener('click', async event => {
    const section = event.target.closest('[data-puffora-cart]');
    if (!section) return;
    if (busy && event.target.closest('a, button, input, .js-change-quantity')) { stop(event); return; }
    const remove = event.target.closest('[data-remove-item="cart-template"]');
    if (!remove || !window.fetch || !window.DOMParser) return;
    const row = remove.closest('[data-cart-key]');
    if (!row) return;
    stop(event);
    busy = true;
    const status = section.querySelector('[data-cart-status]');
    const sectionId = section.dataset.pufforaCart;
    const key = row.dataset.cartKey;
    const locked = Array.from(section.querySelectorAll('input, button, textarea')).map(el => [el, el.disabled]);
    locked.forEach(([el]) => { el.disabled = true; });
    section.setAttribute('aria-busy', 'true');
    row.classList.add('puffora-cart-removing');
    status.textContent = section.dataset.updating;
    status.hidden = false;
    let changed = false;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0, sections: [sectionId], sections_url: location.pathname + location.search })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error('Cart update rejected');
      changed = true;
      let html = cart.sections?.[sectionId];
      if (!html) {
        // A rendering failure can occur after a successful mutation. Retry the read, never the removal.
        const url = new URL(location.href);
        url.searchParams.set('section_id', sectionId);
        const rendered = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
        if (!rendered.ok) throw new Error('Cart render unavailable');
        html = await rendered.text();
      }
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const updated = parsed.querySelector('[data-puffora-cart]');
      if (!updated || updated.dataset.pufforaCart !== sectionId) throw new Error('Invalid cart section');
      // Keep unsaved notes, agreement state and initialized accelerated payment elements.
      ['[data-cart-note]', '.tos_agree', '.additional-checkout-buttons'].forEach(selector => {
        const old = section.querySelector(selector);
        const fresh = updated.querySelector(selector);
        if (old && fresh) fresh.replaceWith(old);
      });
      section.replaceWith(updated);
      document.querySelectorAll('.cart_count').forEach(el => { el.textContent = String(cart.item_count); });
      const newStatus = updated.querySelector('[data-cart-status]');
      newStatus.textContent = updated.dataset.removed;
      newStatus.hidden = false;
      newStatus.focus({ preventScroll: true });
      if (window.PXUTheme?.currency?.show_multiple_currencies && window.currencyConverter) {
        window.currencyConverter.convertCurrencies();
      }
      document.dispatchEvent(new CustomEvent('puffora:cart-updated', { detail: { cart } }));
    } catch (error) {
      // Do not silently navigate or retry a potentially successful POST.
      status.textContent = changed ? section.dataset.renderError : section.dataset.updateError;
      section.querySelector('[data-cart-reload]').hidden = false;
    } finally {
      busy = false;
      locked.forEach(([el, disabled]) => { el.disabled = disabled; });
      row.classList.remove('puffora-cart-removing');
      section.removeAttribute('aria-busy');
    }
  }, true);
  document.addEventListener('submit', event => {
    if (busy && event.target.closest('[data-puffora-cart]')) stop(event);
  }, true);
})();
